module.exports = __webpack_public_path__ + "img/1602347318.c1ea4050.png";